import BaseAPI from "./BaseAPI";
import { foodRecordRoute } from "../routes";

export default class FoodRecordAPI extends BaseAPI {
    constructor(emitterInstance) {
        super(emitterInstance, foodRecordRoute, "food-record");
    }

    async ListByFoodID(foodID) {
        return this._request("get", this._url(`?food_id=${foodID}`));
    }
}
